import React from 'react'
import { useNavigate } from 'react-router-dom'
import './PopUp.scss';
import book from '../../Images/book.png'
import bgnobgs from '../../Images/bgnobgs.png'
import closeMenu from '../../Images/closeMenu.png'

export default function PopUp({ setShowPopUp }) {
    const Navigate = useNavigate()
    return (
        <div className="PopUp">
            <div className="MainBanner">
                <div className="MainBannerHeader">
                    <img onClick={() => {
                        localStorage.setItem("showPopUp", true);
                        setShowPopUp(false)
                    }
                    } src={closeMenu} alt="Garage Door In Chino, CA | Garage  Door Repair In Chino, CA | Garage  Door Services In Chino, CA | Garage  Door Inspection In Chino, CA" />
                </div>
                <div className="MainBannerLeft">
                    <h1>Schedule Your Garage Door Service Today!</h1>
                    <h2>Don't wait until it's too late! Ensure your garage door is safe and functioning efficiently.</h2>
                    <a href="tel:657-255-8745" onClick={() => {
                        localStorage.setItem("showPopUp", true);
                        setShowPopUp(false)
                    }}>Click To Call!</a>
                    <a href="/book" onClick={() => {
                        localStorage.setItem("showPopUp", true);
                        setShowPopUp(false)
                    }}>SCHEDULE ONLINE<img src={book} alt="Garage  Door Cleaning Near Me In Chino, California" /></a>
                </div>
                <div className="MainBannerRight">
                    <img src={bgnobgs} alt="Garage Door In Chino, CA | Garage  Door Repair In Chino, CA | Garage  Door Services In Chino, CA | Garage  Door Inspection In Chino, CA" />
                    <div className="MainBannerRightBubble1"></div>
                    <div className="MainBannerRightBubble2"></div>
                </div>
            </div>
        </div>
    )
}
